import { useRef } from "react";
import { useParams } from "react-router";
import { Box } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import Pagination from "@mui/material/Pagination";
import picturesInfo from "../../utils/images/picturesInfo.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Pagination as SwiperPagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { styleConst } from "../../utils/style";
import { useScreen } from "../../context/ScreenContext";

export const YearHistory = () => {
  const { year } = useParams();
  const imgRef = useRef();

  const [pagination, setPagination] = useState(0);
  const [NbPage, setNbPage] = useState(0);

  const yearInfo = useMemo(() => {
    return picturesInfo.find((singleYear) => singleYear.year === Number(year));
  }, [year]);

  const imagesComponents = useMemo(() => {
    const pictures = [];
    const paginationStart = pagination ? pagination * 20 : 1;
    for (let i = 0; i < 20; i++) {
      const pictureNumber = paginationStart + i;
      if (pictureNumber <= yearInfo.picturesCount) {
        pictures.push(
          <a
            key={i}
            href={`/assets/history/large/tournoi_${year}/${pictureNumber}.jpg`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`/assets/history/mini/tournoi_${year}/${pictureNumber}.jpg`}
              alt={`${year}-${pictureNumber}`}
              key={pictureNumber}
              height={"100%"}
              width={"100%"}
              style={{ objectFit: "contain" }}
            />
          </a>,
        );
      }
    }
    return pictures;
  }, [pagination, year, yearInfo.picturesCount]);

  const handleChangePage = (event, newPage) => {
    if (imgRef.current && imgRef.current.swiper) {
      imgRef.current.swiper.slideTo(0);
    }
    setPagination(newPage - 1);
  };

  const { isSmallScreen } = useScreen();

  useEffect(() => {
    setNbPage(Math.floor(yearInfo.picturesCount / 20));
    setPagination(0);
    if (imgRef.current && imgRef.current.swiper) {
      imgRef.current.swiper.slideTo(0);
    }
  }, [year, yearInfo.picturesCount]);

  return (
    <>
      <section>
        <h2>{year}</h2>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexFlow: "row nowrap",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Pagination
            count={NbPage}
            size="large"
            siblingCount={0}
            boundaryCount={1}
            onChange={handleChangePage}
            page={pagination + 1}
          />
        </Box>
        <Swiper
          ref={imgRef}
          spaceBetween={0}
          slidesPerView={1}
          modules={[Navigation, SwiperPagination]}
          pagination={{
            clickable: true,
            bulletActiveClass:
              "swiper-pagination-bullet-active custom-bullet-active",
          }}
          style={{
            width: isSmallScreen ? "350px" : "840px",
            height: isSmallScreen ? "262px" : "630px",
            "--swiper-pagination-color": styleConst.primaryColor,
          }}
        >
          {imagesComponents.map((singleImage, index) => {
            return <SwiperSlide key={index}>{singleImage}</SwiperSlide>;
          })}
        </Swiper>
        {year === "2026" && (
          <p>
            Merci à Laëtitia Pellegrin, Philippe Bertrand et{" "}
            <a
              href="https://www.instagram.com/aud_reyphoto_?igsh=cm50N3NiYXlrYmhs"
              title="la page Instagram de Audrey Rindone"
              target="_blank"
              rel="noreferrer"
            >
              la photographe professionnelle Audrey Rindone
            </a>{" "}
            pour leurs photos.
          </p>
        )}
        {year === "2025" && (
          <p>
            Merci à Ingrid Armoiry et{" "}
            <a
              href="https://www.audreypics.com/"
              title="le site de Audrey Rindone"
              target="_blank"
              rel="noreferrer"
            >
              la photographe professionnelle Audrey Rindone
            </a>{" "}
            pour leurs photos.
          </p>
        )}
        {year === "2024" && (
          <p>
            Merci à Philippe Bertrand, Sandrine Combe et{" "}
            <a
              href="https://www.audreypics.com/"
              title="le site de Audrey Rindone"
              target="_blank"
              rel="noreferrer"
            >
              la photographe professionnelle Audrey Rindone
            </a>{" "}
            pour leurs photos.
          </p>
        )}
      </section>
      <section
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          justifyContent: "flex-start",
          alignItems: "center",
          margin: "1rem 0",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexFlow: "row wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "0.5rem",
            "& img": {
              xs: {
                width: "10rem",
                maxWidth: "30vw",
                height: "10rem",
                maxHeight: "30vw",
                objectFit: "contain",
              },
              sm: {
                width: "10rem",
                maxWidth: "17vw",
                height: "10rem",
                maxHeight: "17vw",
                objectFit: "contain",
              },
            },
          }}
        >
          {imagesComponents.map((image) => {
            return image;
          })}
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexFlow: "row nowrap",
            justifyContent: "center",
          }}
        >
          <Pagination
            count={NbPage}
            size="large"
            siblingCount={0}
            boundaryCount={1}
            onChange={handleChangePage}
            page={pagination + 1}
          />
        </Box>
      </section>
      {/* TODO: Ajouter les résultats plus tard*/}
    </>
  );
};
